import React from "react";
import { PageConfigTypes } from "../../types/PageTypes";

import AgencyEditListPage from "./AgencyEditListPage";
import AgentsEditPage from "./agents-list/AgentsEditPage";
import AgentIdentification from "./components/AgentIdentification";
import AgentPermissions from "./components/AgentPermissions";
import AgentPaymentGeneric from "./components/AgentPaymentGeneric";
import AgentProvisionGeneric from "./components/AgentProvisionGeneric";
import CreateSubAgentPage from "./agents-list/CreateSubAgentPage";
import SubAgentsListPage from "./agents-list/SubAgentsListPage";

import { ROLES } from "app/constants/roles";
import jwtDecode from "jwt-decode";
import { DecodedTokenType } from "app/types/UserTypes";

const getAuthoritiesFromToken = (): string[] => {
  try {
    const token = localStorage.getItem("jwt_access_token");
    if (!token) return [];
    const decoded = jwtDecode<DecodedTokenType>(token);
    return decoded?.authorities ?? [];
  } catch {
    return [];
  }
};

function AgencyEditPageConfig(data: any): PageConfigTypes {
  const authorities = getAuthoritiesFromToken();
  const isAdmin = authorities.includes(ROLES.ROLE_ADMIN);
  const isAgent = authorities.includes(ROLES.ROLE_AGENT) && !isAdmin;

  const balancesArray = Array.isArray(data) ? data : [];

  const config: PageConfigTypes = {
    baseRoute: {
      path: "/agentedit/:id",
      component: AgencyEditListPage,
      exact: true,


    },

    subRoutes: [
      {
        path: "/agentedit/:id/edit",
        exact: true,
        component: AgentsEditPage,
  
      },
      {
        path: "/agentedit/:id/llogari",
        exact: true,
        component: AgentIdentification,

      },
      {
        path: "/agentedit/:id/privilege",
        exact: true,
        component: AgentPermissions,

      },

      {
        path: "/agentedit/:id/createSubagent",
        exact: true,
        component: CreateSubAgentPage,
     
      },

      {
        path: "/agentedit/:id/subAgents",
        exact: true,
        component: SubAgentsListPage,
  
      },

      ...balancesArray.map((payment: any) => ({
        path: "/agentedit/:id/payments/:currencyId",
        component: () => (
          <AgentPaymentGeneric
            key={payment.currencyResponse.id}
            currencyResponse={payment.currencyResponse}
          />
        ),
       
      })),

      ...balancesArray.map((provision: any) => ({
        path: "/agentedit/:id/provisions/:currencyId",
        component: () => (
          <AgentProvisionGeneric
            key={provision.currencyResponse.id}
            currencyResponse={provision.currencyResponse}
          />
        ),
      
      })),
    ],

    settings: {
      navbar: {
        open: true,
        title: "app.main.agency.agentsList.agentEdit.title",
        subtitle: "app.main.agency.agentsList.agentEdit.title",
        items: [
          {
            to: "/edit",
            primaryText: "app.main.agency.agentsList.agentEdit.title",
            activeStyle: { fontWeight: "bold" },
            icon: "info",
            exact: true,
          },
          {
            to: "/llogari",
            primaryText: "app.main.agency.agentsList.agentEdit.sidebar.title1",
            activeStyle: { fontWeight: "bold" },
            icon: "key",
            activeClassName: "",
            exact: true,
          },
          {
            to: "/privilege",
            primaryText: "app.main.agency.agentsList.agentEdit.sidebar.title2",
            activeStyle: { fontWeight: "bold" },
            icon: "check",
            activeClassName: "",
            exact: true,
          },

          // ADMIN ONLY menu item
          ...(isAdmin
            ? [
                {
                  to: "/subAgents",
                  primaryText: "app.main.agency.agentsList.subAgents.title",
                  activeStyle: { fontWeight: "bold" },
                  icon: "info",
                  exact: true,
                  
                },
              ]
            : []),

          ...balancesArray.map((payment: any) => ({
            to: "/payments/" + payment.currencyResponse.id,
            primaryText: "app.main.agency.config.payment.title",
            secondaryText: payment.currencyResponse.isoCode,
            icon: "attach_money",
            exact: true,
            activeClassName: "",
          })),

          ...balancesArray.map((provision: any) => ({
            to: "/provisions/" + provision.currencyResponse.id,
            primaryText: "app.main.agency.config.provision.title",
            secondaryText: provision.currencyResponse.isoCode,
            icon: "payment",
            exact: true,
            activeClassName: "",
          })),
        ],
      },
    },
  };

  return config;
}

export default AgencyEditPageConfig;
